export enum EDataPaymentActions {
  SET_ESTIMATION_ID = 'dataPayment/setEstimationId',
  SET_DEMAND_REQUEST_STATUS = 'dataPayment/setDemandRequestStatus',
  SET_PHONE = 'dataPayment/setPhone',
  SET_DEAL_TYPE = 'dataPayment/setDealType',
  SEND_DEMAND_REQUEST = 'dataPayment/sendDemandRequest',
  SEND_DEMAND_REQUEST_SUCCESS = 'dataPayment/sendDemandRequestSuccess',
  SEND_DEMAND_REQUEST_ERROR = 'dataPayment/sendDemandRequestError',
}
